import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11db4800"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog modal-xl modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "sms-modal-label"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  id: "smslogs-scoller",
  class: "modal-body"
}
const _hoisted_9 = { class: "message-text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-mobile-alt" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "modal-footer" }

import $ from 'jquery';
import { computed, inject } from 'vue';
import { useStore } from 'vuex';
import { SMSLogs } from "@/models";

export default /*#__PURE__*/_defineComponent({
  __name: 'SMSLogsModal',
  props: {
    name: {},
    title: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const store = useStore();

const actProperty: any = inject('actProperty');

const booking = computed(() => store.getters['diary/booking']);

const getSMSLogs = (bookingid: string): Promise<SMSLogs> => {
  return store.dispatch('diary/getSMSLogs', bookingid);
};
const refresh = () => {
  getSMSLogs(booking.value.id).then(() => {
    const container = document.querySelector("#smslogs-scoller");
    if (container) container.scrollTop = container.scrollHeight;
  });
};
const show = () => {
  if ($(`#${props.name}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.name + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#${props.name}`).show();
  }
}
const hide = () => {
  if ($(`#${props.name}`).length > 0) {
    $(`#${props.name}` + 'Backdrop').remove();
    $(`#${props.name}`).hide();
  }
};
__expose({show, hide });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.name,
    class: "modal",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "`smsmodal-label`",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, _hoisted_7)
        ]),
        (booking.value && booking.value.smslogs)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.smslogs.logs, (log, $index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row message-body",
                  key: $index
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["col-sm-12", {
                'message-main-sender': log.inout === 'in',
                'message-main-receiver': log.inout === 'out',
              }])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass({
                  sender: log.inout === 'in',
                  receiver: log.inout === 'out',
                })
                    }, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(log.message), 1),
                      (log.mobile)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass({
                    'message-time-right': log.inout === 'in',
                    'message-time-left': log.inout === 'out',
                  })
                          }, [
                            _hoisted_10,
                            _createTextVNode(" " + _toDisplayString(log.mobile), 1),
                            _hoisted_11
                          ], 2))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: _normalizeClass({
                    'message-time-right': log.inout === 'in',
                    'message-time-left': log.inout === 'out',
                  })
                      }, _toDisplayString(_unref(actProperty).formatUtcDatetimeForDisplay(log.logdate)), 3)
                    ], 2)
                  ], 2)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary mr-auto",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (refresh()), ["prevent"]))
          }, " Refresh "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            "data-dismiss": "modal",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, " Close ")
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})